import { Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import iaagLogo from "@/assets/iaag-logo.png";

export function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-card border-t border-border/50">
      <div className="section-container py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img
                src={iaagLogo}
                alt="IAAG - It's All About Growth"
                className="h-14 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-muted-foreground text-sm max-w-md">
              {t("footer.description")}
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">{t("footer.navigate")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/growth-system" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.growthSystem")}
                </Link>
              </li>
              <li>
                <Link to="/what-we-build" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.whatWeBuild")}
                </Link>
              </li>
              <li>
                <Link to="/how-we-work" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.howWeWork")}
                </Link>
              </li>
              <li>
                <Link to="/team" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  {t("nav.team")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">{t("footer.connect")}</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:hello@itsallaboutgrowth.com"
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {t("footer.getInTouch")}
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  <Linkedin className="w-4 h-4" />
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/50 mt-12 pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} It's All About Growth. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
